<div class="home-page">
  <div class="center-box">
    <div class="logo">
      <img width="65" height="40" src="../../assets/img/chevron-logo.png" alt="Chevron Logo" />
    </div>
    <div class="app-name">CMP Data Repository</div>
    <button (click)="login()">Login</button>
  </div>
</div>